import { render } from "./DokumenPengadaanBerjalan.vue?vue&type=template&id=a5dbef1c&scoped=true"
import script from "./DokumenPengadaanBerjalan.vue?vue&type=script&lang=js"
export * from "./DokumenPengadaanBerjalan.vue?vue&type=script&lang=js"

import "./DokumenPengadaanBerjalan.vue?vue&type=style&index=0&id=a5dbef1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5dbef1c"]])

export default __exports__